var jQuery = require('jquery');
require('../third/jquery.ajaxmanager');
require('../third/jquery.log');
require('../third/jquery.migrate');
require('../third/jquery.ba-throttle-debounce');


/**
 * Partial update allows AJAX partial update of the DOM structure by communicating with component background implemented
 * in RamJet technology.
 *
 * CUSTOM SETTINGS:
 *
 * alterHistory    - boolean true - if browser history is ought to be altered,
 *                 - boolean false - if browser history should remain untouched
 *                 - (default) not set - only links/forms targeting the same page will alter the history
 * historyScope    - parameters - keeps only parameter values in history
 *                 - (default) allData - default (keeps parameters and all widget values in history - please consider this preset
 *                   when working with private data, such as passwords)
 * clearCache      - boolean true - remembered results are purged before executing call
 *                 - (default) otherwise - nothing
 * htmlContainer   - id of the HTML container to be replaces with returned content (if not set
 *                   it equals containerId passed in the method call)
 * suppressRedirect- boolean true - suppresses full page redirect even if server returns 302 (Moved Temporarily) and performs
 *                   partial update with the result returned from page servers redirects to (when target page contains
 *                   no component required for partial update, content of the update area will get removed!)
 *                 - (default) boolean false - whenever servers responds with 302 (Moved Temporarily) client performs
 *                   full page refresh
 * suppressSubmitEvent - boolean true - when executing function executeSubmit submit event on form DOM element will not be triggered
 *                 - (default) boolean false - executing this function will trigger the event
 * encrypt         - boolean true - if set all parameters will be encrypted with jCryption library when another two
 *                   prerequisities are fulfilled
 *                   a) another JS file /jCryption/jquery.jcryption.js is linked on the page
 *                   b) jCryption servlet filter is configured in the web application
 *                   [note: encryption cannot be used for forms with file inputs = ie. binary data]
 *                 - (default) boolean false
 * layoutContext   - allows to propagate or set layout context ID prefix for the RamJet server side rendering
 *
 * EVENTS:
 *
 * beforeContentsReplaced - before contents of the container are replaced, if method sets false to settings.stopReplacement
 *                          replacement logic will be stopped
 * afterContentsReplaced  - after contents of the container are replaced
 * encryptionInitiated    - before encryption process starts
 * encryptionKeysAcquired - after public key is obtained from the server and before form contents encryption starts
 * encryptionProcessed    - after encryption is finished and before ajax call really starts
 *
 * CALLBACKS:
 *
 * Each method accepts optional reference to a callback function that will be executed on server success response arrival.
 * If callback function is defined it overrides default callback function that replaces existing DOM with new DOM retrieved
 * from the server. So in case you want to add only a bit of custom logic and leave DOM replacement at place you need
 * to have callback in following form:
 *
 * function(replacementDiv, result) {
 *    //your custom logic
 *    $.partialUpdate.predefinedCallbacks.replaceContents(replacementDiv, result)
 *    //your custom logic
 * }
 *
 * @author Jan Novotny
 * @version 1.0
 */

(function($){

	$.partialUpdateManager = function(doQueue, showAjaxPreloader) {
		this.ajaxManager = new $.partialUpdateManager.AjaxManager(doQueue, showAjaxPreloader);
	};

	$.partialUpdateManager.prototype = {

		/**
		 * Logs a text into the firebug.
		 * @param text
		 */
		_log: function(text) {
			if ($.log !== undefined) {
				$.log(text);
			} else if (window.console) {
				window.console.log(text);
			}
		},

		/**
		 * Returns div that contains HTML code of the partially replaced HTML content.
		 */
		_getPartialUpdateReplacementContainer: function(container) {
			/**
			 * This is class constant that is appended to dynamically created divs that are used to replace content
			 * of the partial updated widgets.
			 */
			var partialUpdateContainerClass = "partialUpdateDynamicContainer";

			if (this.length === 0) {
				this._log("Cannot wrap container into the partial update replacement container - no container selected.");
				return null;
			}
			if (this.length > 1) {
				this._log("Cannot wrap container into the partial update replacement container - multiple containers selected.");
				return null;
			}

			var containerParentNode = container.get(0).parentNode;
			if (containerParentNode == null) {
				this._log("Cannot find parent node - another dom replacement probably runs simultaneously!");
				return null;
			}
			var replacementDivAvailable = containerParentNode.className == partialUpdateContainerClass;
			var replacementDiv = replacementDivAvailable ? containerParentNode : null;
			if(replacementDiv === null || replacementDiv === undefined) {
				replacementDiv = document.createElement("div");
				replacementDiv.className = partialUpdateContainerClass;
				container.wrap(replacementDiv);
				replacementDiv = container.get(0).parentNode;
			}
			return $(replacementDiv);
		},

		/**
		 * Composes url with appendend container id at the end.
		 * @param url
		 * @param containerId
		 */
		_composeFinalUrl: function(url, containerId) {
			//compose final url
			var index = url.indexOf("?");
			var indexHash = url.indexOf("#");
			if (indexHash > -1 && (indexHash < index || index == -1)) {
				index = indexHash;
			}
			var requestedContainer = "";
			if ("string" === typeof containerId) {
				requestedContainer = containerId;
			} else {
				for(var i = 0; i < containerId.length; i++) {
					requestedContainer += containerId[i];
					if (i + 1 < containerId.length) {
						requestedContainer += "+";
					}
				}
			}
			if(index > -1) {
				return url.substr(0, index) + "@" + requestedContainer + url.substr(index);
			} else {
				return url + "@" + requestedContainer;
			}
		},

		/**
		 * Finds parent form for sumbit id or retrieves form itself by id. Performs necessary checks for FORM presence
		 * in DOM.
		 * @param submitId
		 */
		_findForm: function(submitId) {
			var jButton = $("#" + submitId);
			if (jButton.length === 0) {
				this._log("Cannot perform partial update - submit or form with id " + submitId + " is not present.");
				return null;
			}
			var jButtonIsForm = jButton.length == 1 && jButton.get(0).tagName.toLowerCase() == "form";
			var jForm = jButtonIsForm ? jButton : jButton.parents("form");

			if (jForm.length == 0) {
				this._log("Cannot perform partial update - form not found.");
				return null;
			}

			return jForm.get(0);
		},

		/**
		 * Returns DOM submit element for passed id. Null if target element is not submit.
		 * @param submitId
		 */
		_findButton: function(submitId) {
			var jButton = $("#" + submitId);
			if (jButton.length === 0) {
				this._log("Cannot perform partial update - submit or form with id " + submitId + " is not present.");
				return null;
			}
			var jButtonIsButton = jButton.length == 1
				&& (
					jButton.get(0).tagName.toLowerCase() == "input" ||
					jButton.get(0).tagName.toLowerCase() == "button"
				)
				&& (
					jButton.get(0).type.toLowerCase() == "submit" ||
					jButton.get(0).type.toLowerCase() == "image" ||
					jButton.get(0).type.toLowerCase() == "button"
				);
			return jButtonIsButton ? jButton.get(0) : null;
		},

		/**
		 * Returns DOM element for the container whose contents should be replaced.
		 * @param containerId
		 * @param settings
		 */
		_getHtmlContainer: function(containerId, settings) {
			var htmlContainer;
			if (settings && settings.htmlContainer) {
				htmlContainer = settings.htmlContainer;
			} else {
				var containerCnt = $("#" + containerId + "__container");
				if (0 < containerCnt.length) {
					//prefer container elements before target ones
					htmlContainer = containerId + "__container";
				} else {
					htmlContainer = containerId;
				}
            }
			var container = $("#" + htmlContainer);
			if (container.length === 0) {
                throw new Error("Cannot perform partial update of the container id " + htmlContainer + " is not present.");
			} else {
				return container;
			}
		},

		/**
		 * Returns true if form is multipart form with file inputs.
		 */
		_isMultipart: function(jForm) {
			var fileInputs = $('input:file', jForm).length > 0;
			var mp = 'multipart/form-data';
			var multipart = (jForm.attr('enctype') == mp || jForm.attr('encoding') == mp);
			jForm.hasClass('noFileUpload');
			return !jForm.hasClass('noFileUpload') && (fileInputs || multipart);
		},

		/**
		 *
		 * @param container
		 * @param result
		 * @param textStatus
		 * @param xhr
		 * @param settings
		 * @param callback
		 * @param containerId
		 * @private
		 */
		_replaceContentsOfSingleWidget: function(container, result, textStatus, xhr, settings, callback, containerId) {
			var me = this;
			//do only single dom manipulation at once
			if (container.get(0).parentNode !== null) {
				var replacementDiv = $.partialUpdate._getPartialUpdateReplacementContainer(container);
				if (replacementDiv === null) {
					return;
				}
				try {
					if ($.isFunction($.partialUpdate.onBeforeReplacement)) {
						var cnt = $.partialUpdate.onBeforeReplacement(replacementDiv, result);
						if (cnt !== undefined) {
							result = cnt;
						}
					}
					container.trigger("beforeContentsReplaced", [result, textStatus, xhr, settings, container]);
					if (!settings || (settings && settings.stopReplacement !== true)) {
						//init callback function
						var finalCallback;
						if (callback === undefined || callback === null) {
							finalCallback = $.partialUpdate.predefinedCallbacks.replaceContents;
						} else {
							finalCallback = callback;
						}
						if (result !== null) {
							if (this.ajaxManager !== undefined) {
								this.ajaxManager._storeAjaxUpdateInBrowserHistory(settings, xhr, containerId);
							}
							finalCallback(replacementDiv, result, null, containerId, settings);
						}
					}
				} catch (e) {
					this._log(e);
				}
				var afterContentsReplaced = function() {
					var accessibleNewContainer = replacementDiv.find("#" + container.attr("id"));
					if (accessibleNewContainer.length !== 0) {
						try {
                            var scrollTrigger = accessibleNewContainer.find(".partial-update-scroll-anchor");
                            if (scrollTrigger.length > 0) {
                                var anchorElement = $(scrollTrigger.get(0));
                                var fixedOffset = anchorElement.attr("data-partial-update-scroll-fixed-offset");
                                var wantedScrollTop = anchorElement.offset().top + (fixedOffset ? parseInt(fixedOffset) : 0);
                                if ($(window).scrollTop() > wantedScrollTop) {
                                    try {
                                        $('html, body').animate({
                                            scrollTop: wantedScrollTop
                                        }, 250);
                                    }
                                    catch(e) {
                                        //ignore
                                    }
                                }
                            }
							accessibleNewContainer.trigger("afterContentsReplaced", [settings]);
						} catch (e) {
							this._log(e);
						}
					} else {
						setTimeout(function() { afterContentsReplaced.call(me) }, 50);
					}
				};
				setTimeout(function() { afterContentsReplaced.call(me) }, 50);
			} else {
				setTimeout(function() { $.partialUpdate._replaceContents.call(me, container, result, textStatus, xhr, settings, callback, containerId) }, 200);
			}
		},

		/**
		 *
		 * @param container
		 * @param result
		 * @param textStatus
		 * @param xhr
		 * @param settings
		 * @param callback
		 * @param containerId
		 * @private
		 */
		_replaceContents: function(result, textStatus, xhr, settings, callback, containerId) {
			var me = this;
			if (xhr.status == 200) {
				//if full page redirect is required make it
				if (xhr.getResponseHeader("FULL_PAGE_REDIRECT")) {
					window.location = xhr.getResponseHeader("FULL_PAGE_REDIRECT");
					return;
				}
				if ("string" === typeof containerId) {
					var htmlContainer = $.partialUpdate._getHtmlContainer(containerId, settings);
					me._replaceContentsOfSingleWidget(htmlContainer, result, textStatus, xhr, settings, callback, containerId);
				} else {
					var prefix = "<!-- RamJet-WidgetDelimiters:";
					var suffix = " -->";
					var pIndex = result.indexOf(prefix);
					var sIndex = result.indexOf(suffix, pIndex + prefix.length);
					if (pIndex > -1 && sIndex > -1) {
						var multipleWidgetDelimiters = result.substr(pIndex + prefix.length, sIndex - (pIndex + prefix.length));
						var widgetResultDelimiters = multipleWidgetDelimiters.split(",");
						var lastIndex = sIndex + suffix.length;
						for(var i = 0; i < widgetResultDelimiters.length; i++) {
							var delimiter = "<!-- " + widgetResultDelimiters[i] + " -->";
							var nextIndex = result.indexOf(delimiter);
							var singleResult = result.substr(lastIndex, nextIndex - lastIndex);

							var htmlContainer = $.partialUpdate._getHtmlContainer(containerId[i], settings);
							me._replaceContentsOfSingleWidget(htmlContainer, singleResult, textStatus, xhr, settings, callback, containerId[i]);

							lastIndex = nextIndex + delimiter.length;
						}
					} else {
						this._log("Server returned unparseable result - expected response starting with: " + prefix + suffix);
					}
				}
			} else {
				this._log("Server returned HTTP: " + xhr.status + " (no partial update performed)");
			}
		},

		predefinedCallbacks: {

			/**
			 * This method will reload whole page if in retrieved HTML contents login dialog is found.
			 * @param replacementDiv
			 * @param contents
			 */
			reloadOnSessionDrop: function(replacementDiv, contents, detectedString) {
				if (detectedString === undefined || detectedString === null) {
					detectedString = "performLogin";
				}
				if (contents.indexOf(detectedString) > -1) {
					this._log("String '" + detectedString + "' detected - session has probably expired, forcing page reload.");
					window.location.reload();
					return null;
				}
			},

			/**
			 * Immediately replaces all partially updated content with no effect.
			 * @param {jQuery} container
			 * @param {string} htmlResult
			 * @param {Function=}
			 * @param {string=} containerId
			 */
			replaceContents: function(container, htmlResult, callback, containerId, settings) {
				container.html(htmlResult);
				if (callback) {
					callback(container, htmlResult);
				}
			},
			/**
			 * Replaces contents of the partially updated content in hidden (nonvisible) state.
			 * @param container
			 * @param htmlResult
			 */
			replaceHidden:   function(container, htmlResult, callback, containerId, settings) {
				container.hide("fast", function() {
					container.html(htmlResult);
					container.show("fast", function() {
						if (callback !== undefined) {
							callback(container, htmlResult);
						}
					});
				});
			},
			/**
			 * Replaces contents of the partially updated content in hidden (nonvisible) state and
			 * fades in content with specified speed.
			 * @param container
			 * @param htmlResult
			 */
			fadeIn:          function(container, htmlResult, speed, callback) {
				var finalSpeed = speed === undefined ? "normal" : speed;
				container.fadeOut(finalSpeed, function() {
					container.html(htmlResult);
					container.fadeIn(finalSpeed, function() {
						if (callback !== undefined) {
							callback(container, htmlResult);
						}
					});
				});
			},
			/**
			 * Replaces contents of the partially updated content in hidden (nonvisible) state and
			 * shows content with specified speed.
			 * @param container
			 * @param htmlResult
			 */
			show:            function(container, htmlResult, speed) {
				var finalSpeed = speed === undefined ? "normal" : speed;
				container.hide(finalSpeed, function() {
					container.html(htmlResult);
					container.show(finalSpeed, function() {
						if (callback !== undefined) {
							callback(container, htmlResult);
						}
					});
				});
			}

		},

		/**
		 * This is callback handler that will be called when HTML is retrieved from the server and before it is attached
		 * to the DOM.
		 */
		onBeforeReplacement: function(replacementDiv, contents) {
			return $.partialUpdate.predefinedCallbacks.reloadOnSessionDrop.call(this, replacementDiv, contents);
		},

		/**
		 * This method will call server with specified url.
		 * Url will be appended with @widgetId so the server side could know whit widget template it should return.
		 * Returned HTML will replace current content of element with containerId.
		 *
		 * @submitId url that points to any of RamJet rendered pages
		 * @containerId id of the HTML element, whose content should be replaced with AJAX returned content
		 *              also id of the widget, whose content is expected to be rendered back
		 * @callback callback function that ought to be called on successful partial form update
		 * @settings additional settings passed into the ajax call - custom settings documented in the header
		 */
		execute: function(url, containerId, callback, settings) {
			var finalUrl = $.partialUpdate._composeFinalUrl(url, containerId);
			var originalErrorFunction = settings && settings.error !== undefined ? settings.error : null;
			//execute post
			$.partialUpdate.ajaxManager.ajaxCall(
				$.extend({}, settings, {
					url: finalUrl,
					type: 'GET',
					dataType: 'html',
					success: function(result, textStatus, xhr) {
						$.partialUpdate._replaceContents(result, textStatus, xhr, settings, callback, containerId);
					},
					error: function(xhr, textStatus, errorThrown) {
						$.partialUpdate._log("Server returned HTTP: " + xhr.status + " " + textStatus + " (" + errorThrown + "). No partial update performed.");
						if (originalErrorFunction !== null) {
							originalErrorFunction(xhr, textStatus, errorThrown);
						}
					}
				})
			);
			return false;
		},

		/**
		 * This method will call server with specified url.
		 * Url will be appended with @widgetId so the server side could know what widget template it should return.
		 * Returned HTML will replace current content of element with containerId.
		 *
		 * @submitId id of the submit widget or form itself
		 * @containerId id of the HTML element, whose content should be replaced with AJAX returned content
		 *              also id of the widget, whose content is expected to be rendered back
		 * @callback callback function that ought to be called on successful partial form update
		 * @settings additional settings passed into the ajax call - custom settings documented in the header
		 * @exceptWidgetData
		 * @exceptWidgetData
		 */
		executeSubmit: function(submitId, containerId, callback, settings, exceptWidgetData, exceptParams) {
			var button = $.partialUpdate._findButton(submitId);
			var form = $.partialUpdate._findForm(submitId);
			if (form === null) return false;

			var formUrl = form.action;
			var attrUrl = $(form).attr('data-partial-update-url');
			if (typeof attrUrl !== 'undefined' && attrUrl !== false) {
				formUrl = attrUrl;
			}
			var url = $.partialUpdate._composeFinalUrl(formUrl, containerId);
			var jForm = $(form);

			var submitFunction = function() {

				var namesToRemove = [];
				exceptWidgetData = settings.removeContainerWidgetData || exceptWidgetData;
				if(exceptWidgetData && containerId){
					namesToRemove = $('[name^="frm."]', $('#' + containerId)).map(function(index, input){
						return input.name;
					}).get();
				}

				if (typeof exceptWidgetData == 'string') {
					//adding frm. prefix
					var widgetDataForRemove = $.map(exceptWidgetData.split(','), function(item){
						return 'frm.' + item;
					});
					//array intersection of all widget data and those in exception
					namesToRemove = widgetDataForRemove.filter(function(n) {
						return namesToRemove.indexOf(n) != -1
					});
				}
				exceptParams = settings.exceptParams || exceptParams;
				if (typeof exceptParams == 'string') {
					//space removal
					exceptParams.replace(/ /, '');
					$.merge( namesToRemove, exceptParams.split(','));
				}

				var originalData = $.extend({}, settings);
				var data = $.merge(
					jForm.serializeArray(),
					settings && settings.data ? settings.data : []
				);

				if(namesToRemove.length > 0){
					$.each(namesToRemove, function(index, name){
						data = $.grep(data, function(item){
							return (item.name != name);
						});
					});
				}


				if(button != null) {
					data[data.length] = {name: button.name, value: ""};
				}

				//for forms default alterHistory = false & clearCache = true
				if(!settings) {
					settings = {alterHistory: false, clearCache: true};
				}
				else {
					if(settings.alterHistory !== true) {
						settings.alterHistory = false;
					}
					if(settings.clearCache !== true) {
						settings.clearCache = true;
					}
				}

				var originalErrorFunction = settings && settings.error !== undefined ? settings.error : null;
				settings = $.extend({}, settings, {
					url: url,
					data: data,
					type: 'POST',
					dataType: 'html',
					success: function (result, textStatus, xhr) {
						$.partialUpdate._replaceContents(result, textStatus, xhr, settings, callback, containerId);
					},
					error: function (xhr, textStatus, errorThrown) {
						$.partialUpdate._log("Server returned HTTP: " + xhr.status + " " + textStatus + " (" + errorThrown + "). No partial update performed.");
						if(originalErrorFunction !== null) {
							originalErrorFunction(xhr, textStatus, errorThrown);
						}
					}
				});
				if($.partialUpdate._isMultipart(jForm)) {
					//translate data to extraData - not to modify external copied code
					if(originalData.data) {
						settings.extraData = {};
						for(var i = 0; i < originalData.data.length; i++) {
							var paramName = originalData.data[i].name;
							var paramValue = originalData.data[i].value;
							settings.extraData[paramName] = paramValue;
						}
					}
					$.partialUpdate.ajaxManager.fileUpload(form, button, settings);
				}
				else {
					//execute post
					$.partialUpdate.ajaxManager.ajaxCall(settings);
				}
			};

			if(settings && settings.suppressSubmitEvent === true) {
				submitFunction();
				return false;
			} else {
				//triggerHandler doesn't work with live events
				//jForm.triggerHandler("submit");
				var submitEvent = new $.Event('submit');
				submitEvent.target = button;
				submitEvent.preventDefault();
				jForm.trigger(submitEvent, [this, submitFunction]);

				if(!submitEvent.stopPartialUpdate) {
					submitFunction();
					return false;
				}

			}

		},

		/**
		 * This method will call server with specified url.
		 * Url will be appended with @widgetId so the server side could know what widget template it should return.
		 * Returned HTML will replace current content of element with containerId.
		 *
		 * @params url with parameters or parameters alone that should be combined along with form data
		 * @submitId id of the submit widget or form itself
		 * @containerId id of the HTML element, whose content should be replaced with AJAX returned content
		 *              also id of the widget, whose content is expected to be rendered back
		 * @callback callback function that ought to be called on successful partial form update
		 * @settings additional settings passed into the ajax call - custom settings documented in the header
		 */
		executeCombi: function(params, submitId, containerId, callback, settings) {
			var button = $.partialUpdate._findButton(submitId);
			var form = $.partialUpdate._findForm(submitId);
			if (form === null) return false;

			//local function for this piece of code
			var replaceValue = function (a, name, value) {
				for (var i = 0; i < a.length; i++) {
					if (a[i].name == name) {
						a[i].value = value;
						return true;
					}
				}
				return false;
			};

			var formUrl = form.action;
			var attrUrl = $(form).attr('data-partial-update-url');
			if (typeof attrUrl !== 'undefined' && attrUrl !== false) {
				formUrl = attrUrl;
			}

			var url = $.partialUpdate._composeFinalUrl(formUrl, containerId);
			var jForm = $(form);

			var submitFunction = function() {
				//for forms default alterHistory = false & clearCache = true
				if (!settings) {
					settings = {alterHistory: false, clearCache: true};
				} else {
					if (settings.alterHistory !== true) {
						settings.alterHistory = false;
					}
					if (settings.clearCache !== true) {
						settings.clearCache = true;
					}
				}

				var data = $.merge(
					jForm.serializeArray(),
					settings && settings.data ? settings.data : []
				);

				var paramsIndex = params.indexOf("?");
				if (paramsIndex > -1) {
					params = params.substring(paramsIndex + 1);
				}
				var paramItems = params.replace("&amp;", "&").split("&");
				for (var i = 0; i < paramItems.length; i++) {
					var paramItem = paramItems[i];
					var nameValue = paramItem.split("=");
					var paramName = decodeURIComponent(nameValue[0] !== undefined ? nameValue[0] : "");
					var paramValue = decodeURIComponent(nameValue[1] !== undefined ? nameValue[1] : "");
					//remove all HTML entities that could be passed in RamJet generated parameters
					var decodedParamValue = $('<div />').html(paramValue).text();
					if (replaceValue(data, paramName, paramValue)) {
						continue;
					}
					data[data.length] = {name: paramName,  value: decodedParamValue};
				}

				var originalErrorFunction = settings && settings.error !== undefined ? settings.error : null;
				//execute post
				$.partialUpdate.ajaxManager.ajaxCall(
					$.extend({}, settings, {
						url: url,
						data: data,
						type: 'POST',
						dataType: 'html',
						success: function(result, textStatus, xhr) {
							$.partialUpdate._replaceContents(result, textStatus, xhr, settings, callback, containerId);
						},
						error: function(xhr, textStatus, errorThrown) {
							$.partialUpdate._log("Server returned HTTP: " + xhr.status + " " + textStatus + " (" + errorThrown + "). No partial update performed.");
							if (originalErrorFunction !== null) {
								originalErrorFunction(xhr, textStatus, errorThrown);
							}
						}
					})
				);
			};

			//triggerHandler doesn't work with live events
			//jForm.triggerHandler("submit");
			var submitEvent = new $.Event('submit');
			submitEvent.target = button;
			submitEvent.preventDefault();
			jForm.trigger(submitEvent, [this, submitFunction]);

			if(!submitEvent.stopPartialUpdate) {
				submitFunction();
				return false;
			}
		},

		/**
		 * This method will add missing container for cases, when there is not yet container with partially updated
		 * content. For example when it represents conditionally available part of the page, that is not loaded
		 * at the first time.
		 *
		 * @param targetContainer
		 * @param containerId
		 */
		addMissingContainer: function(targetContainer, containerId) {
			$("#" + targetContainer).append("<div id='" + containerId + "'></div>");
		}

	};

	/**
	 * Partial update namespace.
	 */

	$.partialUpdateManager.AjaxManager = function(doQueue, showAjaxPreloader) {
		this.doQueue = doQueue;
		this.showAjaxPreloader = showAjaxPreloader;
		this.historyMonitor = null;
		this.preCurrentHash = null;
		this.currentHash = null;
		var me = this;

		/**
		 * Constructor logic.
		 * @param settings
		 */
		if ($.manageAjax !== undefined) {
			var queueName = "partialUpdateQueue";
			this.queueManager = $.manageAjax.create(queueName, {
				queue: true,
				cacheResponse: true,
				abortOld: true
			});
			if (showAjaxPreloader) {
				$(document).bind("mousemove", function(event) { me.moveAjaxLoader.call(me, event) });
				$(document).bind(queueName + "AjaxStart", function() { me.showAjaxLoader.call(me) });
				$(document).bind(queueName + "AjaxStop", function() { me.hideAjaxLoader.call(me) });
				$(document).bind("encryptionInitiated", function() { me.showAjaxLoader.call(me) });
				$(document).bind("encryptionProcessed", function() { me.hideAjaxLoader.call(me) });
			}
		} else {
			this.queueManager = null;
		}

		this._maintainBrowserHistory();
	};

	$.partialUpdateManager.AjaxManager.prototype = {

		/**
		 * This part stores partial update request parameters in location.hash
		 * in order to support back & forward buttons in browsers.
		 * @param xhr
		 */
		_storeAjaxUpdateInBrowserHistory: function(settings, xhr) {
			var baseUrl = xhr.getResponseHeader("RamJet-RequestedUrl");
			var parameters = xhr.getResponseHeader("RamJet-RequestedParameters");
			if (baseUrl) {
				var cmpIndex = baseUrl.indexOf("@");
				if (cmpIndex > -1) {
					baseUrl = baseUrl.substring(0, cmpIndex);
				}
				//only partial update request on the same page are recorded
				var loc = window.location;
				var currentAbsoluteUrl = loc.protocol + "//" + loc.host + loc.pathname;
				var currentRelativeUrl = loc.pathname;

				var stripTrailingSlash = function(str) {
					if('/' == str.substr(-1)) {
						return str.substr(0, str.length - 1);
					}
					return str;
				};

				baseUrl = stripTrailingSlash(baseUrl);
				currentAbsoluteUrl = stripTrailingSlash(currentAbsoluteUrl);
				currentRelativeUrl = stripTrailingSlash(currentRelativeUrl);
				var samePage = currentAbsoluteUrl == baseUrl || currentRelativeUrl == baseUrl;
				//noinspection PointlessBooleanExpressionJS
				var alterHistoryRequired = settings && settings.alterHistory == true;
				//noinspection PointlessBooleanExpressionJS
				var alterHistoryPermitted = settings && settings.alterHistory == false;
				if ((alterHistoryRequired) || (samePage && !alterHistoryPermitted)) {
					var token;
					if (samePage) {
						token = parameters && parameters != "" ? parameters : "";
					} else {
						if (baseUrl.indexOf("http") == 0) {
							token = baseUrl + (parameters && parameters != "" ? "?" + parameters : "");
						} else {
							token = loc.protocol + "//" + loc.host + baseUrl + (parameters && parameters != "" ? "?" + parameters : "");
						}
					}
					var newHash = encodeURIComponent("__partialUpdate:" + token);
					if (this.currentHash && this.currentHash == newHash) {
						return;
					}
					this.preCurrentHash = newHash;
					loc.hash = this.preCurrentHash;
					this.currentHash = this.preCurrentHash;
				}
			}
		},

		/**
		 * This function checks whether current page was not result of partial update logic and
		 * if so it replaces current url with valid one retrieved from hash part.
		 */
		_maintainBrowserHistory: function() {
			var loc = window.location;
			var hash = loc.hash;
			if (hash !== undefined && hash !== null && hash !== "") {
				this.currentHash = loc.hash.substr(1);
				this.preCurrentHash = loc.hash.substr(1);
				hash = decodeURIComponent(hash);
				if (hash.indexOf("__partialUpdate:") == 1) {
					var token = hash.substring(17);
					if (token.indexOf("http") == 0) {
						loc.replace(token);
					} else {
						var params = "" === token ? "" : "?" + token;
						loc.replace(loc.protocol + "//" + loc.host + loc.pathname + params);
					}
					this.historyMonitor = null;
					return;
				}
			}
			//monitor hash changes
			if (this.historyMonitor === null) {
				var me = this;
				var closure = function() { me._checkHistoryChange.call(me) };
				this.historyMonitor = setInterval(closure, 500);
			}
		},

		/**
		 * This method checks whether current has changed according to what is expected.
		 */
		_checkHistoryChange: function() {
			var decodedPreHash = decodeURIComponent(this.preCurrentHash);
			var decodedHash = decodeURIComponent(this.currentHash);
			var cleanWindowHash = decodeURIComponent(window.location.hash.length > 0 ? window.location.hash.substr(1) : "");
			if (cleanWindowHash !== "" && decodedHash && decodedHash != cleanWindowHash && decodedPreHash == decodedHash) {
				this._maintainBrowserHistory.call(this);
			}
		},

		/**
		 * Executes call itself. No other operations are performed around the call - execution is handed over to jQuery
		 * or queueManager.
		 *
		 * @param settings
		 */
		executeAjaxCall: function(settings) {
			if (this.doQueue && this.queueManager !== null) {
				//clear cache
				if (settings.clearCache && $.manageAjax !== undefined) {
					this.queueManager.clearCache();
				}
				//queue requests
				this.queueManager.add(settings);
			} else {
				//no queuing will occur manager not accessible
				$.ajax(settings);
			}
		},

		/**
		 * This performs AJAX call to the server.
		 * @param settings
		 */
		ajaxCall: function(settings) {
			//initialize empty settings if none are provided
			if (!settings) {
				settings = {};
			}
			if (!settings.data) {
				settings.data = [];
			}
			if (settings.suppressRedirect == true) {
				settings.data.push({name: "RamJet-Suppress-Redirect", value: "true"});
			}
			if (settings.layoutContext) {
				settings.data.push({name: 'ramJetLayoutContext', value: settings.layoutContext});
			}
            if (!settings.timeout) {
                settings.timeout = 60000; // default ajax timeout is 1 minute
            }

			//reset cache always when server event is triggered
			var eventRequired = settings.url.indexOf("eventName") > -1;
			for(paramIndex in settings.data) {
				var param = settings.data[paramIndex];
				eventRequired = eventRequired || (param.name && param.name.indexOf("eventName") > -1);
			}
			var AjaxFunction = function(settings, ajaxManager) {
				this.internalSettings = settings;
				this.ajaxManager = ajaxManager;
				this.performCall = function() {
					if (this.internalSettings.alterHistory != false) {
						//set historyScope to request current url and parameters from server if not defined
						if (!this.internalSettings.historyScope) {
							this.internalSettings.historyScope = "parameters";
						}
						this.internalSettings.data.push({name: "RamJet-HistoryScope-Level", value: this.internalSettings.historyScope});
					}
					//clear cache if event is triggered
					if (eventRequired) {
						this.internalSettings.clearCache = true;
						if ($.manageAjax !== undefined) {
							this.ajaxManager.queueManager.clearCache();
						}
					}
					this.ajaxManager.executeAjaxCall.call(this.ajaxManager, this.internalSettings);
				};
				this.replaceDataAndPerformCall = function (newData) {
					this.internalSettings.data = [];
					this.internalSettings.data.push(newData);
					this.performCall();
				};
			};
			var deferredCall = new AjaxFunction(settings, this);
			//convert all params & data into the crypted form
			if (settings.encrypt) {
				//gather all data to encrypt and clear original values
				var dataToEncrypt = "";
				var paramIndex = settings.url.indexOf("?");
				if (paramIndex > -1) {
					dataToEncrypt = settings.url.substr(paramIndex + 1);
					settings.url = settings.url.substr(0, paramIndex);
				}
				for(paramIndex in settings.data) {
					if (dataToEncrypt.length > 0) {
						dataToEncrypt = dataToEncrypt + "&";
					}
					var param = settings.data[paramIndex];
					dataToEncrypt = dataToEncrypt + param.name + "=" + param.value;
				}
				settings.htmlContainer.trigger("encryptionInitiated", [settings]);
				//perform encryption and final partial update
				$.jCryption.getKeys(
					this.getJavaScriptBase() + "jCryption/generateKeyPair",
					function(keys) {
						settings.htmlContainer.trigger("encryptionKeysAcquired", [settings]);
						$.jCryption.encrypt(
							encodeURI(dataToEncrypt), keys,
							function(encryptedData) {
								settings.htmlContainer.trigger("encryptionProcessed", [settings]);
								deferredCall.replaceDataAndPerformCall(
									{name: "jCryption", value: encryptedData}
								);
							}
						);
					}
				);
			} else {
				deferredCall.performCall();
			}
		},

		// Function for handling file uploads (hat tip to YAHOO!)
		// Originally taken from jQuery Form Plugin (http://malsup.com/jquery/form/)
		// Code is licensed under the: http://www.opensource.org/licenses/mit-license.php
		// That allows us to modify and distribute the original code
		// Thank you guys!
		fileUpload: function(form, submit, options) {
			var me = this;
			form = $(form);
			var action = options.url || form.attr('action');
			var url = (typeof action === 'string') ? $.trim(action) : '';
			if (url) {
				// clean url (don't include hash vaue)
				url = (url.match(/^([^#]+)/)||[])[1];
			}
			url = url || window.location.href || '';

			options = $.extend(true, {
				url:  url,
				type: form.attr('method') || 'GET',
				iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank'
			}, options);

			var s = $.extend(true, {}, $.ajaxSettings, options);
			if (!s.extraData) {
				s.extraData = s.extraData || {};
			}
			s.extraData["RamJet-Suppress-Redirect"] = "true";
			if (s.layoutContext) {
				s.extraData["ramJetLayoutContext"] = s.layoutContext;
			}

			s.context = s.context || s;
			var id = 'jqFormIO' + (new Date().getTime()), fn = '_'+id;
			window[fn] = function() {
				var f = $io.data('form-plugin-onload');
				if (f) {
					f();
					window[fn] = undefined;
					try { delete window[fn]; } catch(e){}
				}
			};
			var $io = $('<iframe id="' + id + '" name="' + id + '" src="'+ s.iframeSrc +'" onload="window[\'_\'+this.id]()" />');
			var io = $io[0];

			$io.css({ position: 'absolute', top: '-1000px', left: '-1000px' });

			var xhr = { // mock object
				aborted: 0,
				responseText: null,
				responseXML: null,
				status: 0,
				statusText: 'n/a',
				getAllResponseHeaders: function() {},
				getResponseHeader: function() {},
				setRequestHeader: function() {},
				abort: function() {
					this.aborted = 1;
					$io.attr('src', s.iframeSrc); // abort op in progress
				}
			};

			var g = s.global;
			// trigger ajax global events so that activity/block indicators work like normal
			if (g && ! $.active++) {
				$.event.trigger("ajaxStart");
			}
			if (g) {
				$.event.trigger("ajaxSend", [xhr, s]);
			}

			if (s.beforeSend && s.beforeSend.call(s.context, xhr, s) === false) {
				if (s.global) {
					$.active--;
				}
				return;
			}
			if (xhr.aborted) {
				return;
			}

			var cbInvoked = false;
			var timedOut = 0;

			// add submitting element to data if we know it
			if (submit) {
				var n = submit.name;
				if (n && !submit.disabled) {
					s.extraData = s.extraData || {};
					s.extraData[n] = submit.value;
					if (submit.type == "image") {
						s.extraData[n+'.x'] = form.clk_x;
						s.extraData[n+'.y'] = form.clk_y;
					}
				}
			}

			// take a breath so that pending repaints get some cpu time before the upload starts
			function doSubmit() {
				// make sure form attrs are set
				var t = form.attr('target'), a = form.attr('action');

				// update form attrs in IE friendly way
				var nakedForm = form.get(0);
				nakedForm.setAttribute('target',id);
				if (nakedForm.getAttribute('method') != 'POST') {
					nakedForm.setAttribute('method', 'POST');
				}
				if (nakedForm.getAttribute('action') != s.url) {
					nakedForm.setAttribute('action', s.url);
				}

				// ie borks in some cases when setting encoding
				if (! s.skipEncodingOverride) {
					form.attr({
						encoding: 'multipart/form-data',
						enctype:  'multipart/form-data'
					});
				}

				// support timout
				if (s.timeout) {
					setTimeout(function() { timedOut = true; cb.call(me); }, s.timeout);
				}

				// add "extra" data to form if provided in options
				var extraInputs = [];
				try {
					if (s.extraData) {
						for (var n in s.extraData) {
							extraInputs.push(
								$('<input type="hidden" name="'+n+'" value="'+s.extraData[n]+'" />')
									.appendTo(form)[0]);
						}
					}

					// add iframe to doc and submit the form
					$io.appendTo('body');
					$io.data('form-plugin-onload', cb);
					form.trigger("submit", [$.partialUpdate]);
				}
				finally {
					// reset attrs and remove "extra" input elements
					nakedForm.setAttribute('action',a);
					if(t) {
						nakedForm.setAttribute('target', t);
					} else {
						form.removeAttr('target');
					}
					$(extraInputs).remove();
				}
			}

			if (s.forceSync) {
				doSubmit();
			}
			else {
				setTimeout(function() { doSubmit.call(me) }, 10); // this lets dom updates render
			}

			var data, doc, domCheckCount = 50;

			function cb() {
				if (cbInvoked) {
					return;
				}

				$io.removeData('form-plugin-onload');

				var ok = true;
				try {
					if (timedOut) {
						throw 'timeout';
					}
					// extract the server response from the iframe
					doc = io.contentWindow ? io.contentWindow.document : io.contentDocument ? io.contentDocument : io.document;

					var isXml = s.dataType == 'xml' || doc.XMLDocument || $.isXMLDoc(doc);
					if (!isXml && window.opera && (doc.body == null || doc.body.innerHTML == '')) {
						if (--domCheckCount) {
							// in some browsers (Opera) the iframe DOM is not always traversable when
							// the onload callback fires, so we loop a bit to accommodate
							$.partialUpdate._log('requeing onLoad callback, DOM not available');
							setTimeout(function() { cb.call(me) }, 250);
							return;
						}
					}

					cbInvoked = true;
					xhr.responseText = doc.body ? doc.body.innerHTML : null;

					/**
					 * First comment gets appended before html header instead of body and we need that to detect
					 * multiple widget result delimiters.
					 */
					if (doc.firstChild.nodeType == 8) {
						xhr.responseText = "<!--" + doc.firstChild.nodeValue + "-->" + xhr.responseText;
					}

					xhr.responseXML = doc.XMLDocument ? doc.XMLDocument : doc;
					xhr.status = 200;
					xhr.getResponseHeader = function(header){
						var headers = {'content-type': s.dataType};
						return headers[header];
					};

					var scr = /(json|script)/.test(s.dataType);
					if (scr || s.textarea) {
						// see if user embedded response in textarea
						var ta = doc.getElementsByTagName('textarea')[0];
						if (ta) {
							xhr.responseText = ta.value;
						}
						else if (scr) {
							// account for browsers injecting pre around json response
							var pre = doc.getElementsByTagName('pre')[0];
							var b = doc.getElementsByTagName('body')[0];
							if (pre) {
								xhr.responseText = pre.textContent;
							}
							else if (b) {
								xhr.responseText = b.innerHTML;
							}
						}
					}
					else if (s.dataType == 'xml' && !xhr.responseXML && xhr.responseText != null) {
						xhr.responseXML = toXml(xhr.responseText);
					}
					data = httpData(xhr, s.dataType);
				}
				catch(e){
					$.partialUpdate._log('error caught:',e);
					ok = false;
					xhr.error = e;
					$.handleError(s, xhr, 'error', e);
				}

				if (xhr.aborted) {
					$.partialUpdate._log('upload aborted');
					ok = false;
				}

				// ordering of these callbacks/triggers is odd, but that's how $.ajax does it
				if (ok) {
					s.success.call(s.context, data, 'success', xhr);
					if (g) {
						$.event.trigger("ajaxSuccess", [xhr, s]);
					}
				}
				if (g) {
					$.event.trigger("ajaxComplete", [xhr, s]);
				}
				if (g && ! --$.active) {
					$.event.trigger("ajaxStop");
				}
				if (s.complete) {
					s.complete.call(s.context, xhr, ok ? 'success' : 'error');
				}

				// clean up
				setTimeout(function() {
					$io.removeData('form-plugin-onload');
					$io.remove();
					xhr.responseXML = null;
				}, 100);
			}

			function toXml(s, doc) {
				if (window.ActiveXObject) {
					doc = new ActiveXObject('Microsoft.XMLDOM');
					doc.async = 'false';
					doc.loadXML(s);
				}
				else {
					doc = (new DOMParser()).parseFromString(s, 'text/xml');
				}
				return (doc && doc.documentElement && doc.documentElement.tagName != 'parsererror') ? doc : null;
			}
			var parseJSON = JSON.parse || function(s) {
					return window['eval']('(' + s + ')');
				};

			var httpData = function( xhr, type, s ) { // mostly lifted from jq1.4.4

				var ct = xhr.getResponseHeader('content-type') || '',
					xml = type === 'xml' || !type && ct.indexOf('xml') >= 0,
					data = xml ? xhr.responseXML : xhr.responseText;

				if (xml && data.documentElement.nodeName === 'parsererror') {
					$.error && $.error('parsererror');
				}
				if (s && s.dataFilter) {
					data = s.dataFilter(data, type);
				}
				if (typeof data === 'string') {
					if (type === 'json' || !type && ct.indexOf('json') >= 0) {
						data = parseJSON(data);
					} else if (type === "script" || !type && ct.indexOf("javascript") >= 0) {
						$.globalEval(data);
					}
				}
				return data;
			};

		},

		/**
		 * Returns base JavaScript file path based on current (this) javascript path, which is known.
		 */
		getJavaScriptBase: function() {
			var src = null;
			$("script").each(function() {
				var scriptSrc = $(this).attr("src");
				if (scriptSrc !== undefined && scriptSrc.indexOf("jquery.partialUpdate") > -1) {
					src = scriptSrc;
				}
			});
			if (src !== null) {
				return src.substring(0, src.lastIndexOf("jquery.partialUpdate"));
			} else {
				return null;
			}
		},

		/**
		 * This method will render AJAX loader on the page it it's not already present.
		 */
		showAjaxLoader: function() {
			var htmlLoader = $("#loader");
			if (htmlLoader.length == 0) {
				htmlLoader = $('<div id="loader" style="position: absolute; overflow: hidden; z-index: 1000000;"><img src="data:image/gif;base64,R0lGODlhEAAQAKIGANjY2O7u7mRkZAQEBE5OTr6+vv///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAAGACwAAAAAEAAQAAADKWi63P4wykkVuMBijUPIBuCB4leSozWe6tdeaRifrOza2MWRW+X/wEYCACH5BAkKAAYALAAAAwAEAAsAAAMLOKpE7KO9GaGsdCUAIfkECQoABgAsAAAAABAAEAAAAzFoutz+MMZBhxNYqEGIbUJRaAbnXSJpfkw4bh27uGqMvqUNpvC546tLpieDVIqSpDIBACH5BAkKAAYALAAAAAAQABAAAAM9aLrc/jDKNupwIgs1CBlACChCUWxG9wFBMBrlyXlg+8aoWrukmdMsHsw3W9l6shRQhPx9MJriZWKZTq6PBAAh+QQFCgAGACwAAAAAEAAQAAADMmi63P4wyimFFSADpbcRRYEFgQeQHiieJYcq6tgabBrK5vvdtTvHHY4GdqNcBJSkMpIAACH5BAkKAAYALAYAAwAKAAsAAAMYODrWPoQw16CkNU5q99OY0YUjVnKguYQJACH5BAkKAAYALAAAAAAQABAAAAM8aLrc/jCuQYdUgxBrhBdOtilCUYAGoAIiV54KEASs5pqoTLckHs+1UceXAvKGsOLO1kuugq5PqHKpWiEJACH5BAkKAAYALAAAAAAQABAAAAMzaLrc/jDKKKqYRpRyDfiAAgIaJwZB6KHk1gHsmZZvvM6urMK4ee8smgg0/Fg6mKRyyUgAACH5BAUKAAYALAAAAAAQABAAAAMpaLrc/jDKSRW4wGKNQ8gG4IHiV5KjNZ7q115pGJ+s7NrYxZFb5f/ARgIAIfkEBSMABgAsAAAAAAEAAQAAAwJoCQA7"/></div>');
				$(document.body).append(htmlLoader);
			}
			this.positionAjaxLoader();
			$("#loader").show();
			window.__ajaxLoaderHidden = false;
		},

		/**
		 * This method will hide AJAX preloader.
		 */
		hideAjaxLoader: function() {
			$("#loader").hide();
			window.__ajaxLoaderHidden = true;
		},

		/**
		 * This method monitors mouse move positions and moves the AJAX preloader if it is visible. It also automatically
		 * and temporarily hides preloader if the mouse gets too close to the edges of the page.
		 * @param event
		 */
		moveAjaxLoader: function(event) {
			/** FOR DEBUGGING PURPOSES **/
			/**
			 if ($('#monitor').length == 0) {
                $(document.body).append("<div id='monitor' style='position: absolute; top: 10px; left: 10px;'></div>");
            }
			 $('#monitor').css("top", window.pageYOffset + 10 + "px").html("<b>Mouse X:</b> " + window.__mouseX + "<br><b>Mouse Y:</b> " + window.__mouseY + "<br><b>AJAX on background:</b> " + !window.__ajaxLoaderHidden + "<br><b>Close to border:</b> " + window.__ajaxLoaderHiddenDueToBorder);
			 **/
			if (event.pageX !== undefined && event.pageY !== undefined) {
				window.__mouseX = event.pageX;
				window.__mouseY = event.pageY;
			}
			if (!window.__ajaxLoaderHidden) {
				if (window.__mouseX + 24 + 24 >= window.pageXOffset + $(window).width() ||
					window.__mouseY + 24 + 24 >= window.pageYOffset + $(window).height() ||
					window.__mouseX - 24 <= window.pageXOffset ||
					window.__mouseY - 24 <= window.pageYOffset) {
					window.__ajaxLoaderHiddenDueToBorder = true;
					$("#loader").hide();
				} else {
					if (window.__ajaxLoaderHiddenDueToBorder) {
						window.__ajaxLoaderHiddenDueToBorder = false;
						$("#loader").show();
					}
					this.positionAjaxLoader();
				}
			}
		},

		/**
		 * This method wil alter preloader position relative to the mouse position.
		 */
		positionAjaxLoader: function() {
			$("#loader").css("left", window.__mouseX + 18).css("top", window.__mouseY + 18);
		}

	};

	/**
	 * This could be overwriten in case, queuing and ajax preloading is required to be off on particular site.
	 * Default behaviour - AJAX partial update requests are queued and preloader image is shown when any AJAX
	 * request is running.
	 *
	 * If you want just to change preloader image, provide your own implementation of:
	 * $.partialUpdateManager.AjaxManager.prototype.getPreloaderImage = function() { return "/img/myImage.gif"; }
	 */
	$.partialUpdate = ($.partialUpdate === undefined ? new $.partialUpdateManager(true, true) : $.partialUpdate);

	$.fn.partialUpdate = function(domainWithProtocol, currentPageUrl, settings, callback, overridenContainerId) {
		if (!domainWithProtocol) {
			domainWithProtocol = window.location.protocol + "//" + window.location.host;
		}
		if (!currentPageUrl) {
			currentPageUrl = window.location.pathname;
		}

		var internalPaths = [
			currentPageUrl,
			domainWithProtocol + currentPageUrl
		];

		return this.each(function(){
			var containerId = overridenContainerId ? overridenContainerId : this.id;
			var frmCount = 0;
			var firstForm = null;

			var composeSettings = function (settings, event) {
				var resultSettings = {};
				var additionalSettings = {};
				if($(this).hasClass("clearCache")) {
					additionalSettings.clearCache = true;
				}
				$.extend(resultSettings, settings, additionalSettings);
				var eventTarget = $(event.target);
				var extractNearestAttribute = function(eventTarget, attributeName) {
					var attrValue = eventTarget.attr(attributeName);
					if (typeof attrValue !== 'undefined' && attrValue !== false) {
						return attrValue;
					} else {
						var parentElements = eventTarget.parents("[" + attributeName + "]");
						if (parentElements.length > 0) {
							return $(parentElements.get(0)).attr(attributeName);
						}
					}
				}

				//withdraw partial update parameters from the event target if it is defined
				var additionalData = extractNearestAttribute(eventTarget, "data-partial-update");
				if (additionalData) {
					var dataPUJson = JSON.parse(additionalData);
					$.extend(resultSettings, dataPUJson);
				}
				//withdraw partial update target from the event target if it is defined
				var currentElmPUTarget = extractNearestAttribute(eventTarget, "data-partial-update-target");
				if (currentElmPUTarget) {
					try {
						resultSettings.containerId = JSON.parse(currentElmPUTarget);
					} catch (e) {
						resultSettings.containerId = currentElmPUTarget;
					}
				}
				//withdraw partial update target html container from the event target if it is defined
				var currentElmPUTargetContainer = extractNearestAttribute(eventTarget, "data-partial-update-target-html-container");
				if (currentElmPUTargetContainer) {
					resultSettings.htmlContainer = currentElmPUTargetContainer;
				}
				//add to result settings reference to the originating event
				resultSettings.invokedEvent = event;
				return resultSettings;
			};

			var enhance = function(attribute, paths) {
				if ($.data(this, "enhancedByPartialUpdate") === true) { return false; }
				if ($(this).hasClass("partialUpdate")) { return true; }
				if (attribute) {
					for(var j = 0; j < paths.length; j++) {
						var path = paths[j];
						var hrefAttr = $(this).attr(attribute);
						if (hrefAttr && hrefAttr.indexOf(path) == 0) { return true; }
					}
					return false;
				} else {
					return true;
				}
			};

			//convert all submit buttons of the inside forms targeting same page into partial updates (except those with class "noPartialUpdate")
			var puForms = $(this).find("form").not(".noPartialUpdate");
			if (this.tagName.toLocaleLowerCase() == "form" && !($(this).hasClass("noPartialUpdate"))) {
				if (!this.id || this.id == "") {
					$.partialUpdate._log("Form has no id!");
				} else {
					puForms = puForms.add("#" + this.id, document);
				}
			}
			puForms.each( function() {
				var $thisPuForm = $(this);
				if (enhance.call(this, "action", internalPaths) || enhance.call(this, "data-partial-update-url", internalPaths)) {
					frmCount = frmCount + 1;
					if (firstForm == null) { firstForm = this; }
					//bind trigger for specific event
					$thisPuForm.bind("partialUpdate", function(e) {
						if (!e.isDefaultPrevented()) {
							var $thisForm = $(this);
							var callSettings;
							if (!settings || settings.enhancedSettings === undefined) {
								var enhancedSettings = $.extend({ suppressSubmitEvent: true }, settings);
								callSettings = composeSettings.call(this, enhancedSettings, e);
							} else {
								callSettings = composeSettings.call(this, settings, e);
							}
							var callContainerId = callSettings.containerId ? callSettings.containerId : containerId;
							$.partialUpdate.executeSubmit($thisForm.attr("id"), callContainerId, callback, callSettings);
							return false;
						}
					});
					$thisPuForm.data("enhancedByPartialUpdate", true);
				}
				var buttons1 = $thisPuForm.find("input[type='submit']");
				var buttons2 = $thisPuForm.find("input[type='image']");
				var buttons3 = $thisPuForm.find("button[type='submit']");
				var buttons4 = $thisPuForm.find("button[type='image']");
				var buttons5 = $thisPuForm.find("input[type='button']");
				var buttons = buttons1.add(buttons2).add(buttons3).add(buttons4).add(buttons5);
				buttons.not(".noPartialUpdate").each(function() {
					var $thisSubmit = $(this);
					if (!$thisSubmit.parents().hasClass("noPartialUpdate")) {
						if (enhance.call(this)) {
							$.data(this, "enhancedByPartialUpdate", true);
							$thisSubmit.on("click",
								function(e) {
									if (!e.isDefaultPrevented()) {
										if (!this.id || this.id == "") $.partialUpdate._log("Clicked object has no id!");
										var callSettings = composeSettings.call(this, settings, e);
										var callContainerId = callSettings.containerId ? callSettings.containerId : containerId;
										$.partialUpdate.executeSubmit(this.id, callContainerId, callback, callSettings); return false;
									}
								}
							);
						}
					}
				});
				//convert all anchors of the inside forms (relative url) targeting same page into partial updates (except those with class "noPartialUpdate")
				$(this).find("a").not(".noPartialUpdate").each(function() {
					var $this = $(this);
					if (!$this.parents().hasClass("noPartialUpdate")) {
						if (enhance.call(this, "href", internalPaths)) {
							$.data(this, "enhancedByPartialUpdate", true);
							$this.on("click",
								function(e) {
									if (!e.isDefaultPrevented()) {
										var id = $(this).parents("form").attr("id");
										if (!id || id == "") $.partialUpdate._log("Parent form has no id!");
										var callSettings = composeSettings.call(this, settings, e);
										var callContainerId = callSettings.containerId ? callSettings.containerId : containerId;
										$.partialUpdate.executeCombi(this.href, id, callContainerId, callback, callSettings); return false;
									}
								}
							)
						}
					}
				});
			});

			//convert all inside anchors targeting same page into partial updates (except those with class "noPartialUpdate")
			//links with class 'bindWithForm' will be partially updated with posting all data from the single form in the container element
			$(this).find("a").not(".noPartialUpdate").each(
				function() {
					var $this = $(this);
					if (!$this.parents().hasClass("noPartialUpdate")) {
						if (enhance.call(this, "href", internalPaths)) {
							$.data(this, "enhancedByPartialUpdate", true);
							if ($this.hasClass("bindWithForm") && frmCount == 1) {
								$this.on("click",
									function(e) {
										if (!e.isDefaultPrevented()) {
											var callSettings = composeSettings.call(this, settings, e);
											var callContainerId = callSettings.containerId ? callSettings.containerId : containerId;
											$.partialUpdate.executeCombi(this.href, firstForm.id, callContainerId, callback, callSettings); return false;
										}
									}
								);
							} else {
								$this.on("click",
									function(e) {
										if (!e.isDefaultPrevented()) {
											var callSettings = composeSettings.call(this, settings, e);
											var callContainerId = callSettings.containerId ? callSettings.containerId : containerId;
											$.partialUpdate.execute(this.href, callContainerId, callback, callSettings); return false;
										}
									}
								);
							}
						}
					}
				}
			);
		});
	};

})(jQuery);



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/ramjet/partialUpdate.js